import React from 'react'
import { TableRow, TableData, CellContentWrapper } from './styledComponents';
import moment from 'moment';
import Tooltip from "components/Tooltip";
import Icon from "../Icon";

const formatPhoneNumber = (str) => {
  let cleaned = ('' + str).replace(/\D/g, '');
  let matchWithCountryCode = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }

  if (matchWithCountryCode && matchWithCountryCode[1] === '1') {
    return (
      matchWithCountryCode[1] +
      " (" +
      matchWithCountryCode[2] +
      ") " +
      matchWithCountryCode[3] +
      "-" +
      matchWithCountryCode[4]
    ); 
  }

  return str;
};

const formatDateTime = (str) => {
  return str ? moment(str).format('ll') : '';
}

const formatData = (type, data) => {
  var result = data;
  switch (type) {
    case 'phone':
      result = formatPhoneNumber(data);
      break;
    case 'date':
      result = formatDateTime(data);
      break;
  }

  return result;
};

function RowItem({ columns, data, isEven, isLeadsTable }) {

  return (
    <TableRow isEven={isEven}>
      {columns.map((c, idx) => {
        const cellData = c.customRow
          ? c.customRow(data)
          : formatData(c.type, data[c.path]);

        return (
          <TableData
            key={idx}
            className={c.className}
            isLeadsTable={isLeadsTable}
            width={c.width ? c.width : undefined}
          >
            {cellData}
          </TableData>
        );
      })}
    </TableRow>
  )
}

export default RowItem;



// WEBPACK FOOTER //
// ./src/components/Table/RowItem.js